<div class="container-fluid h-100 d-flex flex-column justify-content-center">
  <div class="row">
    <div class="col-12 text-center">
      <p>
        @if (returning) {
          Returning to your account...
        } @else {
          Logging out...
        }
      </p>
    </div>
  </div>
</div>
